<template>
  <v-layout justify-center my-4>
    <v-card>
      <v-toolbar flat dense color="primary" dark>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer />
        <v-btn v-if="!isFamiliar" flat @click="$emit('form')">
          {{ $t('action.buttons.new') }}
        </v-btn>
      </v-toolbar>

      <v-divider />
      <v-card-text class="pa-0">
        <v-data-table
          :headers="headers"
          :items="formatList"
          disable-initial-sort
        >
          <template slot="items" slot-scope="props">
            <td class="justify-center layout px-0">
              <v-tooltip top>
                <template #activator="{ on }">
                  <v-icon
                    small
                    class="success--text mr-2"
                    v-on="on"
                    @click="$emit('form', items[props.index])"
                  >
                    edit
                  </v-icon>
                </template>
                <span>{{ $t('action.buttons.edit') }}</span>
              </v-tooltip>
              <v-tooltip top>
                <template #activator="{ on }">
                  <v-icon
                    small
                    class="error--text"
                    v-on="on"
                    @click="$emit('delete', props.item)"
                  >
                    delete
                  </v-icon>
                </template>
                <span>{{ $t('action.buttons.delete') }}</span>
              </v-tooltip>
            </td>
            <td>{{ props.item[isFamiliar ? 'name_familiar' : 'name'] }}</td>
            <td>
              {{ props.item[isFamiliar ? 'lastname1_familiar' : 'lastname1'] }}
            </td>
            <td>
              {{
                props.item[isFamiliar ? 'lastname2_familiar' : 'lastname2'] ||
                '--'
              }}
            </td>
            <td>{{ props.item[isFamiliar ? 'gender_familiar' : 'gender'] }}</td>
            <td>
              {{
                props.item[
                  isFamiliar ? 'birthdayDate_familiar' : 'birthdayDate'
                ]
              }}
            </td>
            <td>{{ props.item[isFamiliar ? 'email_familiar' : 'email'] }}</td>
            <td v-if="isFamiliar">
              {{ `${props.item.name} ${props.item.lastname1}` }}
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import { formatDate } from '@/helpers/dateHelper'
export default {
  name: 'UsersBulkCreateList',
  props: {
    title: { type: String },
    items: { type: Array, default: () => [] },
    isFamiliar: { Type: Boolean, default: false },
  },
  computed: {
    ...mapGetters({
      genders: 'users/genders',
    }),
    headers() {
      let headers = [
        {
          text: this.$t('fields.global.actions'),
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('fields.global.name'),
          value: 'name',
          sortable: false,
        },
        {
          text: this.$t('fields.users.lastname'),
          value: 'lastname1',
          sortable: false,
        },
        {
          text: this.$t('fields.users.lastname2'),
          value: 'lastname2',
          sortable: false,
        },
        {
          text: this.$t('fields.users.sex'),
          value: 'gender',
          sortable: false,
        },
        {
          text: this.$t('fields.users.birthdayDate'),
          value: 'birthdayDate',
          sortable: false,
        },
        {
          text: this.$t('fields.users.email'),
          value: 'email',
          sortable: false,
        },
      ]
      if (this.isFamiliar) {
        headers.push({
          text: this.$tc('titles.global.player'),
          value: 'player',
          sortable: false,
        })
      }
      return headers
    },
    formatList() {
      return this.items.map((item) => {
        let result = Object.assign({}, item)
        if (this.isFamiliar) {
          const gender = this.genders.find(
            (gender) => gender.value === item.gender_familiar
          )
          if (gender) result.gender_familiar = gender.text
          result.birthdayDate_familiar = formatDate(item.birthdayDate_familiar)
          result.lastname2_familiar = result.lastname2_familiar || '--'
        } else {
          const gender = this.genders.find(
            (gender) => gender.value === item.gender
          )
          if (gender) result.gender = gender.text
          result.birthdayDate = formatDate(item.birthdayDate)
          result.lastname2 = result.lastname2 || '--'
        }
        return result
      })
    },
  },
}
</script>
